import bellRingingIcon from "@tabler/icons/outline/bell-ringing.svg";
import bellIcon from "@tabler/icons/outline/bell.svg";
import React from "react";
import { defineMessages, useIntl } from "react-intl";

import { useFollowAccount } from "@/api/accounts";
import { IconButton } from "@/components/ui";

import type { Account as AccountEntity } from "@/schemas";

const messages = defineMessages({
  subscribe: {
    id: "account.subscribe",
    defaultMessage: "Subscribe to alerts from @{name}",
  },
  unsubscribe: {
    id: "account.unsubscribe",
    defaultMessage: "Unsubscribe to alerts from @{name}",
  },
});

interface SubscriptionButtonProps {
  account: Pick<AccountEntity, "id" | "username" | "relationship">;
}

const SubscriptionButton = ({ account }: SubscriptionButtonProps) => {
  const intl = useIntl();
  const followAccount = useFollowAccount();

  const isFollowing = account.relationship?.following;
  const isMuting = account.relationship?.muting;
  const isSubscribed = account.relationship?.notifying;
  const title = isSubscribed
    ? intl.formatMessage(messages.unsubscribe, { name: account.username })
    : intl.formatMessage(messages.subscribe, { name: account.username });

  const handleToggle = () => {
    if (account.relationship?.notifying) {
      followAccount.mutate({ account, params: { notify: false } });
    } else {
      followAccount.mutate({ account, params: { notify: true } });
    }
  };

  if (isMuting) {
    return null;
  }

  if (isFollowing) {
    return (
      <IconButton
        src={isSubscribed ? bellRingingIcon : bellIcon}
        onClick={handleToggle}
        title={title}
        variant="outline"
        className="self-stretch px-2"
        iconClassName="h-5 w-5"
      />
    );
  }

  return null;
};

export default SubscriptionButton;
